export const speedRun_v1 = [
  {
    breakerId: 'stylepiggy',
    additionalData: {
      time: -166071,
    },
    position: 0,
  },
  {
    breakerId: 'vitaG',
    additionalData: {
      time: -166326,
    },
    position: 1,
  },
  {
    breakerId: 'Mimosa',
    additionalData: {
      time: -167028,
    },
    position: 2,
  },
  {
    breakerId: 'KayeL',
    additionalData: {
      time: -167862,
    },
    position: 3,
  },
  {
    breakerId: 'AldoDiaz',
    additionalData: {
      time: -179283,
    },
    position: 4,
  },
  {
    breakerId: 'aracern',
    additionalData: {
      time: -183738,
    },
    position: 5,
  },
  {
    breakerId: 'svinya123',
    additionalData: {
      time: -185392,
    },
    position: 6,
  },
  {
    breakerId: 'Inferior',
    additionalData: {
      time: -195827,
    },
    position: 7,
  },
  {
    breakerId: 'Sfinkzzz',
    additionalData: {
      time: -198570,
    },
    position: 8,
  },
  {
    breakerId: 'Neptune',
    additionalData: {
      time: -206120,
    },
    position: 9,
  },
  {
    breakerId: 'KekksikAngry',
    additionalData: {
      time: -209887,
    },
    position: 10,
  },
  {
    breakerId: 'Steven',
    additionalData: {
      time: -210361,
    },
    position: 11,
  },
  {
    breakerId: 'Kos',
    additionalData: {
      time: -231766,
    },
    position: 12,
  },
  {
    breakerId: 'InventorBLADES',
    additionalData: {
      time: -245858,
    },
    position: 13,
  },
  {
    breakerId: 'Cyberya',
    additionalData: {
      time: -272053,
    },
    position: 14,
  },
  {
    breakerId: 'RAVI',
    additionalData: {
      time: -273223,
    },
    position: 15,
  },
  {
    breakerId: 'Zvonock',
    additionalData: {
      time: -303439,
    },
    position: 16,
  },
  {
    breakerId: 'Fistashka',
    additionalData: {
      time: -306721,
    },
    position: 17,
  },
  {
    breakerId: 'ownedmk1',
    additionalData: {
      time: -307130,
    },
    position: 18,
  },
  {
    breakerId: 'Gendalf',
    additionalData: {
      time: -524376,
    },
    position: 19,
  },
];
